module.exports = __webpack_public_path__ + "static/media/breaker.9d603452.jpg";